/* Library */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { browserHistory } from 'react-router';
import RadioButton from '../../../../../components/ZUILib/RadioButton';
import SelectionTab from '../../../../../components/ZUILib/SelectionTab';
import InputButton from '../../../../../components/ZUILib/InputButton';
import ApplyCSS from './../../../../../components/ApplyCSS';
import Link from '../../../../../components/ZUILib/Link';
import commonUtil from '../../../../../utils/commonUtil';
import serverClientUtil from '../../../../../utils/serverClientUtil';
import * as giftOpeningDetailsActions from './actions';
import Warning from '../../../../../components/Warning';
// import { constAPISuccess, constEventStatus } from '../../../../../utils/clientConstant';
import * as defaultConst from '../../../../../utils/clientConstant';
import Tagging from '../../../../../components/Tagging/Tagging';

const { handleGetGiftOpeningDetails, handleSetOpeningGiftForEventDetails } = giftOpeningDetailsActions;
const channel = commonUtil.getChannel();
const pageName = 'giftOpening';
const applicationRoutes = commonUtil.getApplicationRoutes();

class GiftOpening extends Component {
  constructor(props) {
    super(props);
    this.warningMessage = '';
    this.typeOfDelivery = 'false';
    this.errorMessage = '';
    this.eventStatusForSuspended = false;
  }
  UNSAFE_componentWillMount() {
    const user = this.props.user;
    if (!(user && user.result && user.result.status && user.result.status.status === defaultConst.constAPISuccess)) {
      if (browserHistory) {
        browserHistory.push('/');
      }
    }
    this.eventID = this.props.params && this.props.params.eventID ? this.props.params.eventID : null;
    if (this.eventID) {
      this.props.handleGetGiftOpeningDetails(this.eventID);
    }

    // logic for Suspended/Closed event
    const currentEventStatus = this.props.eventStatus;
    currentEventStatus.map((temp) => {
      if (temp.eventId === this.eventID) {
        if ([defaultConst.constEventStatus.SUSPENDED, defaultConst.constEventStatus.VALIDITYOFFACTIVE, defaultConst.constEventStatus.CLOSED].indexOf(temp.eventStatus) > -1) {
          this.eventStatusForSuspended = true;
        }
      } return this.eventStatusForSuspended;
    });
  }
  componentDidMount() {
    const eventUrl = 'gestiondeeventos/RegaloDeApertura/';

    // eslint-disable-next-line no-undef
    dataLayer.push({
      event: 'vPageView',
      GroupOne: eventUrl,
      actURL: window.location.pathname,
      actPageTitle: document.title,
      cdSection: 'Regalo por apertura',
      Site: 'Mesa de Regalos',
      idMesa: this.eventID,
    });
  }
  handleSelectedWeb = (e) => {
    if (e.value === 'domicilio') {
      const dropdown = document.querySelector('#giftDeliveryAddress').style.display;
      if (dropdown === 'none') {
        document.querySelector('#giftDeliveryAddress').style.display = 'block';
      }
      document.querySelector('#address').selectedIndex = 0;
    }
    if (e.value === 'tienda') {
      const radio2 = document.querySelector('#typeOfDelivery_radio2').checked;
      const dropdown = document.querySelector('#button').style.display;
      if (radio2 === 'checked') {
        document.querySelector('#typeOfDelivery_radio1').checked = 'false';
      }
      if (dropdown === 'none') {
        document.querySelector('#button').style.display = 'block';
        document.querySelector('#giftDeliveryAddress').style.display = 'none';
      } else {
        document.querySelector('#giftDeliveryAddress').style.display = 'none';
      }
    }
  }

  handleSelectedWap = (e) => {
    if (e.value === 'domicilio') {
      const dropdown = document.querySelector('#address_send').style.display;
      if (dropdown === 'none') {
        document.querySelector('#address_send').style.display = 'block';
      }
      const buttonSaveforDomicilio = document.querySelector('#buttonSaveforDomicilio').style.display;
      if (buttonSaveforDomicilio === 'none') {
        document.querySelector('#buttonSaveFortienda').style.display = 'none';
      }
      document.querySelector('#address').selectedIndex = 0;
    }
    if (e.value === 'tienda') {
      const radio2 = document.querySelector('#typeOfDelivery_radio2').checked;
      const dropdown = document.querySelector('#button').style.display;
      if (radio2 === 'checked') {
        document.querySelector('#typeOfDelivery_radio1').checked = 'false';
      }
      // condition for save button for tienda
      const buttonSaveFortienda = document.querySelector('#buttonSaveFortienda').style.display;
      if (buttonSaveFortienda === 'none') {
        document.querySelector('#buttonSaveFortienda').style.display = 'block';
        document.querySelector('#buttonSaveforDomicilio').style.display = 'none';
      }
      if (dropdown === 'none') {
        document.querySelector('#buttonSaveforDomicilio').style.display = 'block';
        document.querySelector('#address_send').style.display = 'none';
      } else {
        document.querySelector('#address_send').style.display = 'none';
      }
    }
  }

  showHiddenButton = () => {
    this.OwnerID = this.address.getValue();

    const buttonForWeb = document.querySelector('#button').style.display;
    if (buttonForWeb === 'none') {
      document.querySelector('#button').style.display = 'block';
    }

    if (channel === 'wap') {
      const buttonSaveforDomicilio = document.querySelector('#buttonSaveforDomicilio').style.display;
      if (buttonSaveforDomicilio === 'none') {
        document.querySelector('#buttonSaveforDomicilio').style.display = 'block';
        document.querySelector('#buttonSaveFortienda').style.display = 'none';
      }
    }
  };


  saveGiftOpeningDetails = () => {
    const radioChecked = document.getElementById('typeOfDelivery_radio1').checked;
    const storeSelected = (!radioChecked);

    // Logic for OwnerId and OwnerId is nothing AddressId
    let addressId = '';
    if (!storeSelected) {
      addressId = this.OwnerID;
    }
    handleSetOpeningGiftForEventDetails(this.eventID, (storeSelected).toString(), addressId).then((response) => {
      if (response.body.status.status && response.body.status.status === defaultConst.constAPISuccess) {
        document.querySelector('#skuName').style.display = 'none';
        document.querySelector('#mainTextToHide').style.display = 'none';
        document.querySelector('.radio').style.display = 'none';
        document.querySelector('#button').style.display = 'none';
        document.querySelector('.selectedOptions').style.display = 'block';
        this.eventID = this.props.params && this.props.params.eventID ? this.props.params.eventID : null;
        if (this.eventID) {
          this.props.handleGetGiftOpeningDetails(this.eventID);
        }
        this.warning.setMessage(commonUtil.getLabel(this.props.lables.editEventOpeningGfit, 'editEventOpeningGfit.delivery.preference.success.message'));
        // if (channel === 'wap') {
        //   setTimeout(() => {
        //     this.warning.setMessage('');
        //   }, 15000);
        // }
      }
    });
  }
  showMoreInfoPopOver = () => {
    if (document.querySelector('#popover292887')) {
      document.querySelector('#popover292887').style.display = 'block';
    }
  }
  hideMoreInfoPopOver = () => {
    if (document.querySelector('#popover292887')) {
      document.querySelector('#popover292887').style.display = 'none';
    }
  }
  cancelForWeb = () => {
    const buttonForWeb = document.querySelector('#button').style.display;
    if (buttonForWeb === 'block') {
      document.querySelector('#button').style.display = 'none';
      document.querySelector('#giftDeliveryAddress').style.display = 'none';
    }
    const radio1 = document.querySelector('#typeOfDelivery_radio1').checked;
    if (radio1 === true) {
      document.querySelector('#typeOfDelivery_radio1').checked = false;
    }
    const radio2 = document.querySelector('#typeOfDelivery_radio2').checked;
    if (radio2 === true) {
      document.querySelector('#typeOfDelivery_radio2').checked = false;
    }
  }
  cancelForWap = () => {
    const buttonSaveforDomicilio = document.querySelector('#buttonSaveforDomicilio').style.display;
    if (buttonSaveforDomicilio === 'block') {
      document.querySelector('#buttonSaveforDomicilio').style.display = 'none';
    }
    const dropdown = document.querySelector('#address_send').style.display;
    if (dropdown === 'block') {
      document.querySelector('#address_send').style.display = 'none';
    }
    const radio1 = document.querySelector('#typeOfDelivery_radio1').checked;
    if (radio1 === true) {
      document.querySelector('#typeOfDelivery_radio1').checked = false;
    }
    const radio2 = document.querySelector('#typeOfDelivery_radio2').checked;
    if (radio2 === true) {
      document.querySelector('#typeOfDelivery_radio2').checked = false;
    }
    const buttonSaveFortienda = document.querySelector('#buttonSaveFortienda').style.display;
    if (buttonSaveFortienda === 'block') {
      document.querySelector('#buttonSaveFortienda').style.display = 'none';
    }
    if (radio1 === false && radio2 === false) {
      browserHistory.push(commonUtil.getRouteByParameter(applicationRoutes.eventManagement, { pageName: 'EventManagementIndex', eventID: this.eventID }));
    }
  }
  renderWeb() {
    const { openingGift, setOpeningGift, lables } = this.props;
    // this.openingGiftLabels = labels && labels.editEventOpeningGfit ? labels.editEventOpeningGfit : '';
    if (!openingGift) {
      return false;
    }
    let addressSelected = null;
    let skuSelected = null;
    let finalSku = null;
    let alreadySelected = 'false';
    let storeName = null;
    let selectedCelebrityName = null;
    let pedidoNumber = null;
    let trackingUrl = null;
    if (openingGift && openingGift.status.status === defaultConst.constAPISuccess && openingGift.status.errorMessage) {
      return <h3>{openingGift.status.errorMessage}</h3>;
    } else if (openingGift && openingGift.status.status === defaultConst.constAPISuccess) {
      addressSelected = openingGift && openingGift.openingGiftDetailsForEventInfo && openingGift.openingGiftDetailsForEventInfo.addressInfo ? openingGift.openingGiftDetailsForEventInfo.addressInfo.map(address => ({ option: address.addressId, value: address.addressName })) : [];
      skuSelected = openingGift && openingGift.openingGiftDetailsForEventInfo && openingGift.openingGiftDetailsForEventInfo.skuInfo ? openingGift.openingGiftDetailsForEventInfo.skuInfo.map(skuName => skuName.skuName) : [];
      finalSku = setOpeningGift && setOpeningGift.giftSkus ? setOpeningGift.giftSkus.map(skuName => skuName.skuName) : [];
      alreadySelected = openingGift && openingGift.openingGiftDetailsForEventInfo.alreadySelected;
      storeName = openingGift && openingGift.openingGiftDetailsForEventInfo.storeName;
      selectedCelebrityName = openingGift && openingGift.openingGiftDetailsForEventInfo.selectedCelebrityName;
      pedidoNumber = openingGift && openingGift.openingGiftDetailsForEventInfo.pedidoNumber;
      trackingUrl = openingGift.openingGiftDetailsForEventInfo.url;
    }

    const cancelButtonWeb = {
      id: 'button',
      type: 'button',
      value: 'Cancelar',
      autoFocus: false,
      classname: 'btnSecondaryAction size-Medium',
      cssStyle: { 
        backgroundColor: '#ADA8A8',
        marginRight: '3%',
        borderRadius: '4px'
      },
      onClickHandler: this.cancelForWeb,
    };
    const saveButtonWeb = {
      id: 'button',
      type: 'button',
      value: 'Guardar',
      autoFocus: false,
      classname: 'btnPrimary size-Medium',
      cssStyle: { 
        borderRadius: '4px'
      },
      onClickHandler: this.saveGiftOpeningDetails,
    };
    const addressSelection = (
      <div id="giftDeliveryAddress" className="giftDeliveryAddress toHide" style={{ display: 'none' }}>
        <p>Asigna dirección de envío</p>
        <a
          className="popUpTooltip"
          aria-hidden="true"
          href="javascript:void(0)"
          tabIndex="0"
          role="button"
          onMouseOver={this.showMoreInfoPopOver}
          onMouseLeave={this.hideMoreInfoPopOver}
          data-content="Selecciona la dirección para la entrega de tu regalo"
          data-original-title="" title=""
        ><i className="icon-ayuda" /></a>
        <div
          className="popover fade top in"
          role="tooltip" id="popover292887"
          style={{ top: '146px', left: '65.3281px' }}
        >
          <div
            className="arrow"
            style={{ left: '50%' }}
          />
          <div className="popover-content">Selecciona la dirección para la entrega de tu regalo</div>
        </div>
        <SelectionTab
          id="address"
          classname="cSelect required"
          /* optionCaption="Selecciona Preferencia" */
          optionCaption={commonUtil.getLabel(lables.editEventDelivery, 'eventManagement.address.selectPreferences')}
          options={addressSelected}
          optionText={'value'}
          optionValue={'option'}
          handleSelectedOption={this.showHiddenButton}
          ref={el => (this.address = el)}
        />
      </div>);

    const typeOfDelivery = {
      htmlId: 'typeOfDelivery',
      title: 'typeOfDelivery',
      displayName: 'typeOfDelivery',
      name: 'typeOfDelivery',
      options: [
        {
          id: 'typeOfDelivery_radio2',
          value: 'tienda',
          title: 'Entrega en tienda',
          displayName: 'Entrega en tienda',
          labelResourceId: 'Entrega en tienda',
        },
      ],
    };
    if (openingGift && openingGift.status.status === defaultConst.constAPISuccess) {
      return (
        <div className="col-md-9 addressIntro">
          <h1 className="titleSection">Regalo por apertura</h1>
          <Warning 
            type="success" 
            text={this.warningMessage} 
            ref={warning => this.warning = warning} 
          />
          {alreadySelected === 'false' ?
            <React.Fragment>
              <Tagging ref={tagging => this.tagging = tagging} />
              <ApplyCSS pageName={pageName} />
              <p 
                id="mainTextToHide" className="mainText toHide" 
                style={{ display: 'block', padding: '2% 0 1% 0'  }} >
                  {commonUtil.getLabel(lables.giftOpening, "openGiftMessage")}
              </p>
              <div className="selectedOptions" style={{ display: 'none' }} >
                <p>Regalo seleccionado: <span>{finalSku + ' '}</span></p>
                <p>Dirección de Envío: <span>{setOpeningGift && setOpeningGift.shippingType ? setOpeningGift.shippingType : null}</span></p>
              </div>              
              <div id="skuName" className="giftItem toHide">
                <p style={{display: 'flex', alignItems: 'center',  textTransform: 'uppercase'}}>
                  <span style={{marginRight: '1%'}}>
                    <svg 
                      width="20" 
                      height="20" 
                      viewBox="0 0 20 20" 
                      fill="none" 
                      xmlns="http://www.w3.org/2000/svg">
                      <path 
                          fill-rule="evenodd" 
                          clip-rule="evenodd" 
                          d="M15.0461 4.00326C15.4062 3.59476 15.6063 3.06371 15.6063 2.45097C15.6063 1.22548 
                          14.6459 0.245087 13.4854 0.245087C12.6051 0.245087 10.5643 1.59313 9.72393 
                          2.81862C8.88359 1.59313 6.84278 0.285936 5.96242 0.285936C4.80196 0.285936 3.84158 
                          1.26633 3.84158 2.49182C3.84158 3.06371 4.04166 3.59476 4.4018 
                          3.96241H0.280151V9.27286H1.4006V19.567H7.32297H12.1649H18.0873V9.27286H19.2077V3.96241L15.0461 
                          4.00326ZM11.3246 4.82025V18.75H8.12329V4.82025H11.3246ZM13.4854 1.06208C14.2057 
                          1.06208 14.806 1.67483 14.806 2.49182C14.806 3.18626 14.3258 3.79901 13.7255 
                          3.92156H12.1249H11.3246H10.4442C10.2441 3.83986 10.1641 3.79901 10.1641 3.75816C10.1641 
                          3.02286 12.6051 1.06208 13.4854 1.06208ZM9.32377 3.71731C9.32377 3.79901 9.1637 3.83986 
                          9.08367 3.88071H8.1633H7.36298H5.80236C5.20212 3.75816 4.72193 3.14541 4.72193 
                          2.45097C4.72193 2.28757 4.72193 2.16502 4.76194 2.04247C4.96202 1.47058 5.44222 
                          1.06208 6.00244 1.06208C6.84278 1.06208 9.32377 3.02286 9.32377 3.71731ZM1.08047 
                          8.49672V4.7794H7.32297V8.49672H1.08047ZM2.20092 18.75V9.27286H7.32297V18.7091V18.75H2.20092ZM17.287 
                          18.75H12.1649V18.7091V9.27286H17.287V18.75ZM18.4074 8.49672H12.1649V4.7794H15.006H18.4074V8.49672Z" 
                          fill="#ADA8A8"
                      />
                    </svg>
                  </span>
                  {addressSelected && (skuSelected && skuSelected.length) && 
                  skuSelected.map((sku, ind) => { if (ind !== skuSelected.length - 1) { return sku + ', '; } return sku; })}
                </p>
              </div>
              <div className="toHide" >
                {typeOfDelivery.options.map((option, index) => (
                  <RadioButton
                    key={index}
                    displayName={option.displayName}
                    id={option.id} value={option.value}
                    title={option.title} radioCssClass={'radio'}
                    name={typeOfDelivery.name}
                    disabled={this.eventStatusForSuspended && 'disabled'}
                    onChangeFunction={e => this.handleSelectedWeb(e)}
                  >{option.children}
                  </RadioButton>
                ))}

              </div>

              <div id="button" className="buttonBlock toHide" style={{ display: 'none', textAlign: 'right' }}>
                <InputButton buttonAttr={cancelButtonWeb} />
                <InputButton buttonAttr={saveButtonWeb} />
              </div>

            </React.Fragment> :
            <React.Fragment>
              <div className="selectedOptions" style={{ display: 'block' }}>
                <p>Regalo: {addressSelected && (skuSelected && skuSelected.length) && skuSelected.map((sku, ind) => <span>{ind !== skuSelected.length - 1 ? sku + ', ' : sku}</span>)}</p>
                {storeName && <p>{storeName}</p>}
                {selectedCelebrityName && <p>Entrega a domicilio: <span>{selectedCelebrityName}</span></p>}
              </div>

              {pedidoNumber ?
                <div>
                  <hr />
                  <div className="selesctedGift">
                    <h2 className="subtitleModule">Regalo enviado</h2>
                    <h2 className="subtitleModule">No. de pedido: {pedidoNumber}</h2>
                  </div>
                  <p className="mainText">{this.openingGiftLabels && commonUtil.getLabel(this.openingGiftLabels, 'editEventOpeningGfit.delivery.status.message')}</p>
                  <Link isNotSamePage linkJSON={{ href: serverClientUtil.getLPURL() + (trackingUrl.replace('.jsp',''))+'?SearchOrder=true&TrackingNo='+pedidoNumber, id: pedidoNumber, cssClass: 'primaryColorLink' }}>Ver status de entrega <i className="icon-flecha_gruesa_derecha" /></Link>
                </div>
                : null}
            </React.Fragment>
          }
        </div>
      );
    }
    return (
      <React.Fragment>
        <Tagging ref={tagging => this.tagging = tagging} />
        <ApplyCSS pageName={pageName} />
        <div className="col-md-9 addressIntro">
          <h1 className="titleSection">Regalo por apertura</h1>
          <div className="alertError">
            <i className="icon-tache2" />
            <p>{openingGift.errorMessage}</p>
          </div>
        </div>
      </React.Fragment>
    );
  }

  renderWap() {
    const { openingGift, setOpeningGift, lables } = this.props;
    // this.openingGiftLabels = labels && labels.editEventOpeningGfit ? labels.editEventOpeningGfit : '';
    if (!openingGift) {
      return false;
    }
    let addressSelected = null;
    let skuSelected = null;
    let finalSku = null;
    let alreadySelected = 'false';
    let storeName = null;
    let selectedCelebrityName = null;
    let pedidoNumber = null;
    let trackingUrl = null;
    if (openingGift && openingGift.status.status === defaultConst.constAPISuccess && openingGift.status.errorMessage) {
      return <h4>{openingGift.status.errorMessage}</h4>;
    } else if (openingGift && openingGift.status.status === defaultConst.constAPISuccess) {
      addressSelected = openingGift && openingGift.openingGiftDetailsForEventInfo && openingGift.openingGiftDetailsForEventInfo.addressInfo ? openingGift.openingGiftDetailsForEventInfo.addressInfo.map(address => ({ option: address.addressId, value: address.addressName })) : [];
      skuSelected = openingGift && openingGift.openingGiftDetailsForEventInfo && openingGift.openingGiftDetailsForEventInfo.skuInfo ? openingGift.openingGiftDetailsForEventInfo.skuInfo.map(skuName => skuName.skuName) : [];
      finalSku = setOpeningGift && setOpeningGift.giftSkus ? setOpeningGift.giftSkus.map(skuName => skuName.skuName) : [];
      alreadySelected = openingGift && openingGift.openingGiftDetailsForEventInfo.alreadySelected;
      storeName = openingGift && openingGift.openingGiftDetailsForEventInfo.storeName;
      selectedCelebrityName = openingGift && openingGift.openingGiftDetailsForEventInfo.selectedCelebrityName;
      pedidoNumber = openingGift && openingGift.openingGiftDetailsForEventInfo.pedidoNumber;
      trackingUrl = openingGift.openingGiftDetailsForEventInfo.url;
    }

    const cancelButtonWap = {
      id: 'button',
      type: 'button',
      value: 'Cancelar',
      autoFocus: false,
      classname: 'btnSecondaryAction btnFull',
      cssStyle: { 
        backgroundColor: '#ADA8A8',
        borderRadius: '4px'
      },
      onClickHandler: this.cancelForWap,
    };
    const saveButtonWap = {
      id: 'button',
      type: 'button',
      value: 'Guardar',
      autoFocus: false,
      classname: 'btnPrimary btnFull',
      cssStyle: { 
        borderRadius: '4px'
      },
      onClickHandler: this.saveGiftOpeningDetails,
    };
    const addressSelection = (
      <React.Fragment>
        <div className="row" id="address_send" style={{ display: 'none' }}><b>Asigna dirección de envío</b>
          <div className="formBlock">
            <SelectionTab
              id="address"
              classname="cSelect required"
              optionCaption={commonUtil.getLabel(lables.editEventDelivery, 'eventManagement.address.selectPreferences')}
              options={addressSelected}
              optionText={'value'}
              optionValue={'option'}
              handleSelectedOption={this.showHiddenButton}
              ref={el => (this.address = el)}
            />
          </div>
          <div id="buttonSaveforDomicilio" className="buttonBlock" style={{ display: 'none' }}>
            <div className="col-xs-12 fullWidth">
              <InputButton buttonAttr={saveButtonWap} />
            </div>
          </div>
        </div>

      </React.Fragment>
    );

    const typeOfDelivery = {
      htmlId: 'typeOfDelivery',
      title: 'typeOfDelivery',
      displayName: 'typeOfDelivery',
      name: 'typeOfDelivery',
      options: [
        {
          id: 'typeOfDelivery_radio2',
          value: 'tienda',
          title: 'Entrega en tienda',
          displayName: 'Entrega en tienda',
          labelResourceId: 'Entrega en tienda',
        },
      ],
    };
    if (openingGift && openingGift.status.status === defaultConst.constAPISuccess) {
      return (
        <React.Fragment>
          <Warning type="success" text={this.warningMessage} ref={warning => this.warning = warning} />
          {alreadySelected === 'false' ?
            (<div className="myEventContent">
              <Tagging ref={tagging => this.tagging = tagging} />
              <ApplyCSS pageName={pageName} />
              <div className="col-md-12">
                <h1 className="noBorder" style={{textAlign: 'center', paddingTop: '3%'}}>
                  Regalo por apertura
                </h1>
                <p 
                  id="mainTextToHide" 
                  className="informativeTextSecond" 
                  style={{ display: 'block', padding: '1% 0' }}
                >
                    {commonUtil.getLabel(lables.giftOpening, "openGiftMessage")}
                </p>
                <div className="selectedOptions" style={{ display: 'none' }} >
                  <p>Regalo seleccionado: <span>{finalSku + ' '}</span></p>
                  <p>Dirección de Envío: <span>{setOpeningGift && setOpeningGift.shippingType ? setOpeningGift.shippingType : null}</span></p>
                </div>
                <div id="skuName" className="giftItem toHide">
                  <p className="mainText">
                    {commonUtil.getLabel(lables.giftOpening, "openGifTitleWap")}
                  </p>
                  <p style={{display: 'flex', textTransform: 'uppercase'}}>
                    <span style={{marginRight: '2%'}}>
                      <svg 
                        width="20" 
                        height="20" 
                        viewBox="0 0 20 20" 
                        fill="none" 
                        xmlns="http://www.w3.org/2000/svg">
                        <path 
                            fill-rule="evenodd" 
                            clip-rule="evenodd" 
                            d="M15.0461 4.00326C15.4062 3.59476 15.6063 3.06371 15.6063 2.45097C15.6063 1.22548 
                            14.6459 0.245087 13.4854 0.245087C12.6051 0.245087 10.5643 1.59313 9.72393 
                            2.81862C8.88359 1.59313 6.84278 0.285936 5.96242 0.285936C4.80196 0.285936 3.84158 
                            1.26633 3.84158 2.49182C3.84158 3.06371 4.04166 3.59476 4.4018 
                            3.96241H0.280151V9.27286H1.4006V19.567H7.32297H12.1649H18.0873V9.27286H19.2077V3.96241L15.0461 
                            4.00326ZM11.3246 4.82025V18.75H8.12329V4.82025H11.3246ZM13.4854 1.06208C14.2057 
                            1.06208 14.806 1.67483 14.806 2.49182C14.806 3.18626 14.3258 3.79901 13.7255 
                            3.92156H12.1249H11.3246H10.4442C10.2441 3.83986 10.1641 3.79901 10.1641 3.75816C10.1641 
                            3.02286 12.6051 1.06208 13.4854 1.06208ZM9.32377 3.71731C9.32377 3.79901 9.1637 3.83986 
                            9.08367 3.88071H8.1633H7.36298H5.80236C5.20212 3.75816 4.72193 3.14541 4.72193 
                            2.45097C4.72193 2.28757 4.72193 2.16502 4.76194 2.04247C4.96202 1.47058 5.44222 
                            1.06208 6.00244 1.06208C6.84278 1.06208 9.32377 3.02286 9.32377 3.71731ZM1.08047 
                            8.49672V4.7794H7.32297V8.49672H1.08047ZM2.20092 18.75V9.27286H7.32297V18.7091V18.75H2.20092ZM17.287 
                            18.75H12.1649V18.7091V9.27286H17.287V18.75ZM18.4074 8.49672H12.1649V4.7794H15.006H18.4074V8.49672Z" 
                            fill="#ADA8A8"
                        />
                      </svg>
                  </span>
                    {
                      (skuSelected && skuSelected.length) && skuSelected.map(sku => 
                      <React.Fragment>
                        <h2 style={{fontSize: '16px', paddingTop: '1%'}}>
                          {sku}
                        </h2>
                      </React.Fragment>
                      )
                    }
                  </p>
                </div>
                <div className="row" >
                  {typeOfDelivery.options.map((option, index) => (
                    <RadioButton
                      key={index}
                      displayName={option.displayName}
                      id={option.id} value={option.value}
                      title={option.title} radioCssClass={'radio'}
                      name={typeOfDelivery.name}
                      onChangeFunction={e => this.handleSelectedWap(e)}
                      disabled={this.eventStatusForSuspended && 'disabled'}
                    >{option.children}
                    </RadioButton>
                  ))}
                </div>

                <div id="buttonSaveFortienda" className="buttonBlock" style={{ display: 'none' }}>
                  <div className="col-xs-12 fullWidth">
                    <InputButton buttonAttr={saveButtonWap} />
                  </div>
                </div>
                <div className="col-xs-12 fullWidth">
                  <InputButton buttonAttr={cancelButtonWap} />
                </div>

              </div>
            </div>) :
            <div className="col-md-9 oppeningContainer">
              <div className="col-md-9 addressIntro">
                <h1 className="titleSection">Regalo por apertura</h1>
                <div className="selectedOptionsNow">
                  <p className="mainText">Regalo: <span>{skuSelected + ''}</span></p>

                  <p className="mainText">Dirección de Envío: <span>{storeName || selectedCelebrityName}</span></p>
                </div>
                <hr />
                {pedidoNumber ?
                  <div>
                    <div className="selesctedGift">
                      <h2 className="subtitleModule">Regalo enviado</h2>
                      <h2 className="subtitleModule">No. de pedido: {pedidoNumber}</h2>
                    </div>
                    <p className="mainText">{this.openingGiftLabels && commonUtil.getLabel(this.openingGiftLabels, 'editEventOpeningGfit.delivery.status.message')}</p>
                    <Link isNotSamePage linkJSON={{ href: serverClientUtil.getLPURL() + (trackingUrl.replace('.jsp',''))+'?SearchOrder=true&TrackingNo='+pedidoNumber, id: pedidoNumber, cssClass: 'primaryColorLink' }}>Ver status de entrega <i className="icon-flecha_gruesa_derecha" /></Link>
                  </div>
                  : null}
              </div>
            </div>
          }
        </React.Fragment>

      );
    }
    return (
      <div className="oppeningContainer">
        <Tagging ref={tagging => this.tagging = tagging} />
        <ApplyCSS pageName={pageName} />
        <div className="col-md-9 addressIntro">
          <h1 className="titleSection">Regalo por apertura</h1>
          <div className="alertError">
            <i className="icon-tache2" />
            <p>{openingGift.errorMessage}</p>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        {channel === 'web' ? this.renderWeb() : this.renderWap()}
      </div>
    );
  }

}

const mapStateToProps = state => ({
  openingGift: state.openingGift.data,
  setOpeningGift: state.openingGift.data1,
  dataForOwnerID: state.eventDetails.userEventDetails.eventDetailsInfo.celebrityInfo,
  eventStatus: state.eventDetail.data?.eventList,
  labels: state.labels.data,
});
const matchDispatchToProps = dispatch => bindActionCreators({ handleGetGiftOpeningDetails }, dispatch);
export default connect(mapStateToProps, matchDispatchToProps)(GiftOpening);